var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('in-viewport',[_c('div',{staticClass:"cooperation-section"},[_c('base-layout',{attrs:{"underline":""}},[_c('border-box',{attrs:{"slot":"sidebar"},slot:"sidebar"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.heading)}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('people-list',{attrs:{"people":_vm.people}})],1)],1)],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2286867a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Team/CooperationSection.vue
// module id = null
// module chunks = 